import apiClient from './api'

interface LoginInterface {
    dta_timestamp_stats: string
    dta_zone_stats: string
    dta_loc_stats: string
    dta_captcha_stats: string
    dta_time_stats: string
}

export const SejelLoginService = (data: LoginInterface) =>
    apiClient.post('/microservice/v2/sejel/login', data)

export const UpgradeCertificateService = (data: LoginInterface) => apiClient.post('microservice/v2/sejel/certificate/request/upgrade', data)
